import { Label } from "north.js";
import React from "react";
import styled from "styled-components";

interface RoleLabelsProps {
  roles: string[];
  numShown?: number;
  direction?: "row" | "column";
}

const RoleLabels = ({
  roles,
  numShown,
  direction = "row",
}: RoleLabelsProps) => {
  numShown = numShown ?? roles.length;
  const shownRoles = roles.slice(0, numShown);
  const numRolesHidden = roles.length - numShown;

  return (
    <RoleLabelsContainer direction={direction}>
      {shownRoles.map((role, index) => (
        <RoleLabel key={`${role}-${index}`} color="secondary-light">
          {role}
        </RoleLabel>
      ))}
      {numRolesHidden > 0 && (
        <RoleLabel color="secondary-light">+{numRolesHidden}</RoleLabel>
      )}
    </RoleLabelsContainer>
  );
};

const RoleLabelsContainer = styled.div<{ direction?: "row" | "column" }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex-direction: ${({ direction }) => direction ?? "row"};
  max-width: 100%;
`;

const RoleLabel = styled(Label)`
  flex: none;
  white-space: nowrap;
`;

export default RoleLabels;
